export const FinanceDetailsQuestions = {
  financeAmount: {
    titleKey: 'affordabilityCalculator.financeDetails.financingAmount.title',
    textKey: 'affordabilityCalculator.financeDetails.financingAmount.text',
    maxProfile: {
      1500000: {
        minFtvInclusive: 0,
        maxFtvInclusive: 80,
      },
      1000000: {
        minFtvInclusive: 80.0000000001,
        maxFtvInclusive: 90,
      },
    },
    min: 50000,
  },
  deposit: {
    titleKey: 'affordabilityCalculator.financeDetails.deposit.title',
    textKey: 'affordabilityCalculator.financeDetails.deposit.text',
  },
  ftv: {
    titleKey: 'affordabilityCalculator.financeDetails.ftv.title',
    textKey: 'affordabilityCalculator.financeDetails.ftv.text',
    defaultValue: 100,
  },
  product: {
    titleKey: 'affordabilityCalculator.financeDetails.product.title',
    textKey: 'affordabilityCalculator.financeDetails.product.text',
    placeholderKey: 'placeholders.product',
    options: [
      { label: '2 year | Fixed', value: '2 year | Fixed', productType: 'Fixed' },
      { label: '5 year | Fixed', value: '5 year | Fixed', productType: 'Fixed' },
      { label: '10 year | Fixed', value: '10 year | Fixed', productType: 'Fixed' },
      { label: '2 year | Discount', value: '2 year | Discount', productType: 'Discount' },
    ],
  },
  term: {
    titleKey: 'affordabilityCalculator.financeDetails.term.title',
    textKey: 'affordabilityCalculator.financeDetails.term.text',
    placeholdersKeys: [
      'affordabilityCalculator.financeDetails.term.years.placeholder',
      'affordabilityCalculator.financeDetails.term.months.placeholder',
    ],
  },
  numberOfApplicants: {
    titleKey: 'affordabilityCalculator.financeDetails.numberOfApplicants.title',
    textKey: 'affordabilityCalculator.financeDetails.numberOfApplicants.text',
    options: [
      { labelKey: 'numbers.1', value: 1 },
      { labelKey: 'numbers.2', value: 2 },
    ],
  },
  region: {
    titleKey: 'affordabilityCalculator.financeDetails.region.title',
    textKey: 'affordabilityCalculator.financeDetails.region.text',
    placeholderKey: 'placeholders.select',
  },
  dependants: {
    titleKey: 'affordabilityCalculator.financeDetails.dependents.title',
    textKey: 'affordabilityCalculator.financeDetails.dependents.text',
    options: [
      { labelKey: 'numbers.0', value: 0 },
      { labelKey: 'numbers.1', value: 1 },
      { labelKey: 'numbers.2', value: 2 },
      { labelKey: 'numbers.3', value: 3 },
      { labelKey: 'numbers.4', value: 4 },
      { labelKey: 'numbers.5+', value: 5 },
    ],
  },
  error: {
    min: 'affordabilityCalculator.common.minError',
    max: 'affordabilityCalculator.common.maxError',
    minimumDeposit: 'affordabilityCalculator.common.minimumDepositError',
    required: 'common.error.requiredField',
  },
};
